import React from 'react';

import {PageMenu} from '../components/PageMenu';

export const TradePage: React.FC = () => (
  <main>
    <PageMenu active="/trade" />

    <section className="pb-20 pt-16">
      <div className="mx-auto max-w-[840px] px-4">
        <h1 className="mb-9 mt-8 text-center text-3xl font-light text-neutral-900">
          特定商取引法に基づく表示
        </h1>
        <dl className="overflow-hidden text-sm">
          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            販売事業主名
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            株式会社エムセック
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            代表{'　'}小畠{'　'}勘次
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            運営責任者
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            取締役{'　'}小畠{'　'}祐輝
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            本社所在地
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">〒723-0014</dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            広島県三原市城町一丁目12-5{'　'}エムセックビル
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            問い合わせ先
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            0848-63-5584（代表）
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            営業時間:{'　'}9:00 〜 17:30
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            (土日祝、年末年始、GWを除く)
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            問い合わせフォーム
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            <a className="text-primary underline" href="/contact">
              https://ac-mihara.jp/contact
            </a>
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            営業時間外のお問い合わせにつきましては、翌営業日以降のご回答となります。
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            問い合わせ先メールアドレス
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            unyo+acm@msec.co.jp
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            可能な限り上記の問い合わせフォームからご連絡をお願いたします。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            営業時間外のお問い合わせにつきましては、翌営業日以降のご回答となります。
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            サービス名
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            「ACTION CENTER MIHARA」（ACミハラ）
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            商品代金
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・チケット毎に税込み価格で表示しております。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・利用スペース毎に税込価格で表示しております。
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            商品代金以外の必要料金
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            銀行振込手数料
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            代金の支払い方法
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・クレジットカード決済
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">・銀行振込</dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            代金の支払い時期
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・クレジットカード払いの場合
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            チケットまたはスペース予約のお申込時およびイベント当日の３１日前に与信処理を行い、イベント翌日に決済処理を行います。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・銀行振込の場合
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            チケットのお申込み後にお支払い案内メールをお送りします。お支払案内メールに記載されているお支払期限内に代金をお支払ください。
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            商品の引き渡し時期
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・スペース予約の場合
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            スペースご利用日当日が役務の提供時期となります。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・チケット申込の場合
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            イベント前日にメール送信を行うことで引渡が完了します。
          </dd>

          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            返品・キャンセルについて
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            商品の性質上、原則、商品の返品・キャンセルはお受けしておりませんが、以下の場合のみ、返品・キャンセルを承ります。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・イベント開催日時までに注文者自身がイベント主催者側へ返品・キャンセルの依頼を行い、イベント主催者側がこれを承諾した場合
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            尚、銀行振込の場合、および、クレジットカード払いにて支払日から50日以上経過している場合、ご注文1件あたり500円の手数料を頂戴いたします。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            また、以下の場合は購入されたチケットを返品・キャンセルしチケット代金全額をご返金いたします。
          </dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            ・イベント主催者の事情によりイベントが中止となり、イベント主催者が当社所定の方法でイベントのキャンセル手続きを行った場合
          </dd>
        </dl>
      </div>
    </section>
  </main>
);
